@if (open()) {
  <div class="modal__backdrop" (click)="onBackdropClick()">
    <div class="modal__dialog" tabindex="-1" (click)="$event.stopPropagation()">
      <header class="modal__header">
        <h2>{{ title() }}</h2>
        <button class="modal__close" (click)="close()">✕</button>
      </header>
      <div class="modal__content">
        <ng-content />
      </div>
    </div>
  </div>
}
